import axios from 'axios';
import { Category } from '../../CRUD/CampSites/types';

export const getCategories = async (apiUrl: string, token: string) => {
  try {
    const response = await axios.get<{ success: boolean; message: string | null; data: Category[] }>(`${apiUrl}/Category/getCategories`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    if (response.data.success) {
      return response.data.data;
    } else {
      console.error('Error fetching categories:', response.data.message);
      return [];
    }
  } catch (error) {
    console.error('Error fetching categories:', error);
    return [];
  }
};

export const addCategory = async (apiUrl: string, category: Category) => {
  try {
    const token = localStorage.getItem('accessToken');
    const response = await axios.post<{ success: boolean; message: string | null; data: Category }>(`${apiUrl}/Category/addCategory`, category, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    if (response.data.success) {
      return response.data.data;
    } else {
      console.error('Error adding category:', response.data.message);
      return null;
    }
  } catch (error) {
    console.error('Error adding category:', error);
    return null;
  }
};

export const updateCategory = async (apiUrl: string, category: Category) => {
  try {
    const token = localStorage.getItem('accessToken');
    const response = await axios.put<{ success: boolean; message: string | null; data: Category }>(`${apiUrl}/Category/updateCategory/${category.id}`, category, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    if (response.data.success) {
      return response.data.data;
    } else {
      console.error('Error updating category:', response.data.message);
      return null;
    }
  } catch (error) {
    console.error('Error updating category:', error);
    return null;
  }
};

export const deleteCategory = async (apiUrl: string, id: number) => {
  try {
    const token = localStorage.getItem('accessToken');
    const response = await axios.delete<{ success: boolean; message: string | null; data: boolean }>(`${apiUrl}/Category/deleteCategory/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    if (response.data.success) {
      return response.data.data;
    } else {
      console.error('Error deleting category:', response.data.message);
      return false;
    }
  } catch (error) {
    console.error('Error deleting category:', error);
    return false;
  }
};